import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Action } from 'modules/payroll_integrations_a3innuva/lib/IncidenceSync/store'

const title = (action: Action) => {
  switch (action) {
    case Action.Create:
      return i18n.t('payroll_integrations.incidences.a3innuva.leave.available.create.title')
    case Action.Update:
      return i18n.t('payroll_integrations.incidences.a3innuva.leave.available.update.title')
    case Action.Delete:
      return i18n.t('payroll_integrations.incidences.a3innuva.leave.available.delete.title')
    default:
      throw new Error(`Rendering unknown action ${action}`)
  }
}

const message = (action: Action) => {
  switch (action) {
    case Action.Create:
      return i18n.t('payroll_integrations.incidences.a3innuva.leave.available.create.message')
    case Action.Update:
      return i18n.t('payroll_integrations.incidences.a3innuva.leave.available.update.message')
    case Action.Delete:
      return i18n.t('payroll_integrations.incidences.a3innuva.leave.available.delete.message')
    default:
      throw new Error(`Rendering unknown action ${action}`)
  }
}

const callToAction = (action: Action) => {
  switch (action) {
    case Action.Create:
      return i18n.t('payroll_integrations.incidences.a3innuva.leave.available.create.submit')
    case Action.Update:
      return i18n.t('payroll_integrations.incidences.a3innuva.leave.available.update.submit')
    case Action.Delete:
      return i18n.t('payroll_integrations.incidences.a3innuva.leave.available.delete.submit')
    default:
      throw new Error(`Rendering unknown action ${action}`)
  }
}

const Available = ({
  onSync,
  syncing,
  action,
}: {
  onSync: () => void
  syncing: boolean
  action: Action
}) => {
  return (
    <>
      <Text.Header2>{title(action)}</Text.Header2>
      <Box>{message(action)}</Box>
      <Button onClick={onSync} disabled={syncing}>
        {callToAction(action)}
      </Button>
    </>
  )
}

export default Available
